export default "/logo_blue.svg"